import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { AssessmentProfileResult } from "src/app/_models/AssessmentProfileResultDto";
import { AssessmentProfileActionTypes } from "src/app/constants/StoreConstants";

export const GetAssessmentProfile = createAction(
  AssessmentProfileActionTypes.GetAssessmentProfile,
  props<{ learnerId: number, courseId: number }>(),
);

export const GetAssessmentProfileSuccess = createAction(
  AssessmentProfileActionTypes.GetAssessmentProfileSuccess,
  props<{ result: AssessmentProfileResult }>(),
);

export const GetAssessmentProfileError = createAction(
  AssessmentProfileActionTypes.GetAssessmentProfileError,
  props<{ error: HttpErrorResponse }>(),
);

export const ResetGetAssessmentProfileState = createAction(
  AssessmentProfileActionTypes.ResetGetAssessmentProfileState,
);